<template>
	<div v-show="ready" ref="headerContainer" id="header_container"></div>
</template>

<script>
export default {
	data() {
		return {
			keyword: '',
			ready: false,
			commanded: false
		};
	},
	created() {
		this.keyword = window.config.keyword;
	},
	mounted() {
		this.fetchHeader();
	},
	methods: {
		navClick: function(evt) {
			const current = evt.target;
			const firstParent = evt.target.parentNode;
			const secondParent = firstParent.parentNode;
			let drop = false;

			if (current.classList.contains('dropdown')) {
				drop = current;
			}

			if (firstParent.classList.contains('dropdown')) {
				drop = firstParent;
			}

			if (secondParent.classList.contains('dropdown')) {
				drop = secondParent;
			}

			if (drop) {
				if (drop.classList.contains('open')) {
					drop.classList.remove('open');
				} else {
					drop.classList.add('open');
				}
			}
		},
		fetchHeader: function() {
			const req = new Request(
				`https://${this.keyword}.libnet.info/vheader`
			);
			fetch(req)
				.then(response => response.text())
				.then(html => this.processHeader(html));
		},
		processHeader: function(html) {
			const dummy = document.createElement('div');
			const sr = this.$refs.headerContainer.attachShadow({
				mode: 'open'
			});
			dummy.innerHTML = html;

			const links = dummy.querySelectorAll('link');
			links.forEach(link => {
				const h = link.getAttribute('href');
				if (h && h.indexOf('/css') === 0) {
					dummy.removeChild(link);
					link.href = `https://${this.keyword}.libnet.info${h}`;
					dummy.appendChild(link);
				}
			});

			const scripts = dummy.querySelectorAll('script');

			scripts.forEach(script => {
				try {
					if (script.parentNode === dummy) {
						dummy.removeChild(script);
					}
				} catch (err) {
					/* Don't need to stop, we just don't want it to stop */
				}
			});

			dummy.appendChild(
				this.buildLink(
					'font/eot',
					'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0'
				)
			);
			dummy.appendChild(
				this.buildLink(
					'font/eot',
					'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0'
				)
			);
			dummy.appendChild(
				this.buildLink(
					'font/woff2',
					'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0'
				)
			);
			dummy.appendChild(
				this.buildLink(
					'font/woff',
					'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.woff?v=4.7.0'
				)
			);
			dummy.appendChild(
				this.buildLink(
					'font/ttf',
					'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf?v=4.7.0'
				)
			);
			dummy.appendChild(
				this.buildLink(
					'font/svg',
					'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular'
				)
			);
			sr.innerHTML = dummy.innerHTML;
			sr.appendChild(
				this.getScriptTag('https://use.fontawesome.com/11e4db1f6b.js')
			);

			sr.addEventListener('click', e => {
				const collapseToggle = e.target.closest(
					'[data-toggle="collapse"]'
				);
				if (collapseToggle) {
					const collapse = sr.querySelectorAll('.navbar-collapse');
					if (collapse && collapse.length > 0) {
						collapse[0].classList.toggle('collapse');
						collapse[0].classList.toggle('in');
					}
				}
			});

			sr.querySelectorAll('.dropdown').forEach(dd => {
				dd.addEventListener('click', evt => {
					this.commanded = true;
					this.navClick(evt);
				});
			});

			//run custom init code which is attached to elements and embedded in the template
			const frontendvueload = dummy.querySelectorAll('[data-onload]');
			frontendvueload.forEach(el => {
				let elementInitScript = el.dataset['onload'];
				try {
					eval(elementInitScript);
				} catch (e) {
					console.error('error in eval for data-onload attribute', e);
				}
			});

			setTimeout(
				function() {
					this.ready = true;
				}.bind(this),
				250
			);
		},
		buildLink: function(type, href) {
			const a = document.createElement('link');
			a.rel = type;
			a.href = href;
			return a;
		},
		getScriptTag: function(src) {
			const a = document.createElement('script');
			a.src = src;
			return a;
		}
	}
};
</script>
<style lang="scss">
#header_container {
	margin: 0 auto;
	transition: visibility 0s linear 0s, opacity 300ms;
	width: 100%;
	margin: 0px 10px 0px 10px;
}
</style>
